import {
  RobustnessReq,
  RobustnessDef,
  RobustnessStatusDef,
  RobustnessResultDef
} from "../type/robustness-def";

export class RobustnessAdapter {
  static toInputDTO(req: RobustnessReq): any {
    return {
      estimate_effect_method_type: req.estimate_effect_method_type || "backdoor.generalized_linear_model",
      prior_type: req.prior_type || "BDeu",
      equivalent_sample_size: req.equivalent_sample_size || 30,
      estimate_refute: req.estimate_refute || true,
    };
  }

  static toOutputDTO(res: any): RobustnessDef {
    return res;
  }

  static toOutputStatusDTO(res: any): RobustnessStatusDef {
    return res;
  }

  static toOutputResultDTO(res: any): RobustnessResultDef {
    return res;
  }
}
